// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { getOutstandingApi } from '../../api/OutstandingApi'; // Adjust the path as needed
import { getOutstandingSuccess, getOutstandingFailure } from './actions';

// Saga to handle fetching Outstandings
function* fetchOutstandingSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getOutstandingApi, action.payload);
        yield put(getOutstandingSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getOutstandingFailure(errorMessage));
    }
}

export default function* OutstandingSaga() {
    yield takeEvery('GET_OUTSTANDING_REQUEST', fetchOutstandingSaga);
}
